import { Helmet } from "react-helmet";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ContactUsSection from "./ContactUsSection";
import FAQSection from "./FAQSection";
import React from "react";

export default function ContactUsPage() {
  return (
    <>
      <Helmet>
        <title>Contact Zwilling Labs - Get in Touch with Our Team</title>
        <meta
          name="description"
          content="Reach out to Zwilling Labs for cutting-edge digital solutions. Connect with us for queries, demos, and to discuss our case studies and industry-specific services."
        />
      </Helmet>
      <div className="w-full bg-white">
        <Header className="rounded-bl-[34px] rounded-br-[34px] bg-blue_gray-900" />
          {/* contact us section */}
        <ContactUsSection />
        <div className="mt-40 mb-3 bg-gray-50 py-[108px] md:py-5">
          {/* f a q section */}
          <FAQSection />
        </div>
        <Footer className="rounded-tl-[34px] rounded-tr-[34px] bg-gradient1 sm:py-[5%]" />
        </div>
    </>
  );
}
